import { render, staticRenderFns } from "./caseDataParent.vue?vue&type=template&id=434600de&scoped=true&"
import script from "./caseDataParent.vue?vue&type=script&lang=js&"
export * from "./caseDataParent.vue?vue&type=script&lang=js&"
import style0 from "./caseDataParent.vue?vue&type=style&index=0&id=434600de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434600de",
  null
  
)

export default component.exports